var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlSeefTowerPolygon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 323,
    viewBox: "0 0 73 323",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5 321.5L1.5 314C12.6667 215.5 36.5 11.5999 36.5 5.99989C36.5 0.399891 39.8333 0.666558 41.5 1.49989L66 26.9999L72 45.9999L63.5 109L72 108.5L58 230H53L48.5 272C53.8333 273.833 66.6786 284.5 67 289C67.1429 291 44 314 36.5 321.5Z",
    fill: "#007349",
    fillOpacity: 0.4,
    stroke: "#4DAC89"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlSeefTowerPolygon);
export default __webpack_public_path__ + "static/media/al_seef_tower_polygon.3ebdcb709de5993e7a57488ad2ccafb9.svg";
export { ForwardRef as ReactComponent };